import classNames from 'classnames';
import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { ToolTip } from '../../elements';

type TrueFalseUndefined = true | false | undefined;

export function EditPanelTrueFalseUndefined(props: {
    name: string;
    placeholder?: string;
    value: TrueFalseUndefined;
    onChange: (value: TrueFalseUndefined, name: string) => void;
    topLabel?: string;
    toolTip?: string;
    disabled?: boolean;
    trueText?: string;
    falseText?: string;
    undefinedText?: string;
    size: 'small' | 'medium' | 'large';
}) {
    const translate = useTranslate();

    const {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        disabled = false,
        trueText = translate('common.yes'),
        falseText = translate('common.no'),
        undefinedText = translate('common.all'),
    } = props;

    const trueClassNames: Record<string, boolean> = {};
    const undefinedClassNames: Record<string, boolean> = {};
    const falseClassNames: Record<string, boolean> = {};

    if (props.value) {
        trueClassNames['btn-primary'] = true;
    } else if (props.value === undefined) {
        undefinedClassNames['btn-primary'] = true;
    } else {
        falseClassNames['btn-primary'] = true;
    }

    let styles: { buttonMargin: string };
    if (props.size === 'small') {
        styles = { buttonMargin: '2px' };
        trueClassNames['btn-xs'] = true;
        undefinedClassNames['btn-xs'] = true;
        falseClassNames['btn-xs'] = true;
    } else if (props.size === 'medium') {
        trueClassNames['btn-sm'] = true;
        undefinedClassNames['btn-sm'] = true;
        falseClassNames['btn-sm'] = true;
        styles = { buttonMargin: '5px' };
    } else {
        trueClassNames['btn-lg'] = true;
        undefinedClassNames['btn-lg'] = true;
        falseClassNames['btn-lg'] = true;
        styles = { buttonMargin: '10px' };
    }

    return (
        <>
            {props.topLabel && <span className="ml5">{props.topLabel}</span>}
            <label>
                <button
                    type="button"
                    className={classNames(trueClassNames)}
                    disabled={disabled}
                    onClick={() => props.onChange(true, props.name)}
                    style={{ margin: styles.buttonMargin }}
                >
                    {trueText}
                </button>
                <button
                    type="button"
                    className={classNames(undefinedClassNames)}
                    disabled={disabled}
                    onClick={() => props.onChange(undefined, props.name)}
                    style={{ margin: styles.buttonMargin }}
                >
                    {undefinedText}
                </button>
                <button
                    type="button"
                    className={classNames(falseClassNames)}
                    disabled={disabled}
                    onClick={() => props.onChange(false, props.name)}
                    style={{ margin: styles.buttonMargin }}
                >
                    {falseText}
                </button>
                <span className="mt15">
                    {props.placeholder} {ToolTip({ text: props.toolTip })}
                </span>
            </label>
        </>
    );
}
